/* Categoría estilo Amazon: carga más productos al ir bajando, filtros en una hoja y orden sin perder los filtros */
(function () {
  if (window.__amzColeccion) { window.__amzColeccion(); return }
  function iniciar () {
    document.querySelectorAll('[data-amz-coleccion]').forEach(function (raiz) {
      if (raiz.dataset.amzListo) return; raiz.dataset.amzListo = '1'
      // Orden: conserva los filtros que ya estén puestos
      raiz.querySelectorAll('[data-amz-orden]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault(); var u = new URL(location.href); u.searchParams.set('sort_by', a.dataset.amzOrden); u.searchParams.delete('page'); location.href = u.toString()
        })
      })
      // Filtros
      var hoja = raiz.querySelector('[data-amz-filtros]')
      if (hoja) {
        document.body.appendChild(hoja)
        raiz.querySelectorAll('[data-amz-abrir-filtros]').forEach(function (b) { b.addEventListener('click', function () { hoja.hidden = false; document.documentElement.classList.add('amzl-bloqueo') }) })
        hoja.querySelectorAll('[data-amz-cerrar-filtros]').forEach(function (b) { b.addEventListener('click', function () { hoja.hidden = true; document.documentElement.classList.remove('amzl-bloqueo') }) })
        var form = hoja.querySelector('form')
        form.addEventListener('submit', function () { form.querySelectorAll('input[type=number]').forEach(function (i) { if (!i.value) i.disabled = true }) })
      }
      // Más productos al ir bajando
      var rejilla = raiz.querySelector('[data-amz-rejilla]')
      /* EL PRODUCTO DE LA FOTO VA PRIMERO (20-oct-2026, Pablo: «cuando le doy clic, el producto que se
         vio ahí primero y después los demás»). Los cuadros del inicio enlazan /collections/x?primero=<handle>:
         se busca su tarjeta en la cuadrícula y se sube al primer lugar. Si no está en esta página, no se toca. */
      try {
        var primero = new URLSearchParams(location.search).get('primero')
        if (primero && rejilla && /^[a-z0-9-]+$/.test(primero)) {
          var enlace = rejilla.querySelector('a[href*="/products/' + primero + '"]')
          var item = enlace
          while (item && item.parentElement !== rejilla) item = item.parentElement
          if (item && item !== rejilla.firstElementChild) rejilla.insertBefore(item, rejilla.firstElementChild)
        }
      } catch (e) {}
      function cargar (mas) {
        if (!mas || mas.classList.contains('is-cargando')) return
        mas.classList.add('is-cargando')
        fetch(mas.dataset.amzSiguiente).then(function (r) { return r.text() }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html')
          var nueva = d.querySelector('[data-amz-rejilla]'), sig = d.querySelector('[data-amz-siguiente]')
          if (nueva) Array.prototype.forEach.call(nueva.children, function (c) { rejilla.appendChild(document.importNode(c, true)) })
          if (sig) { mas.dataset.amzSiguiente = sig.dataset.amzSiguiente; mas.querySelector('a').href = sig.dataset.amzSiguiente; mas.classList.remove('is-cargando') } else mas.remove()
        }).catch(function () { mas.classList.remove('is-cargando') })
      }
      var mas = raiz.querySelector('[data-amz-siguiente]')
      if (mas && 'IntersectionObserver' in window) {
        mas.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); cargar(mas) })
        new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) cargar(e.target) }) }, { rootMargin: '700px 0px' }).observe(mas)
      }
    })
  }
  /* Tarjeta: elegir la variante con sus fotitos o pastillas, como en el ejemplo de Moon Shop */
  function precioAmz (c) {
    var n = Math.round(Number(c) || 0), e = Math.floor(n / 100), ct = String(n % 100).padStart(2, '0')
    return '<span class="amzp"><span class="amzp__q">Q</span><span class="amzp__e">' + e.toLocaleString('en-US') + '</span><span class="amzp__c">' + ct + '</span></span>'
  }
  function dinero (c) { var n = (Number(c) || 0) / 100; return 'Q' + (n % 1 ? n.toFixed(2) : n.toLocaleString('en-US')) }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-opcion]'); if (!b) return
    var card = b.closest('[data-amz-tarjeta]'); if (!card) return
    e.preventDefault()
    var vars = card._vars || (card._vars = JSON.parse(card.querySelector('[data-variantes]').textContent))
    var oi = Number(b.dataset.opcion)
    card.querySelectorAll('[data-opcion="' + oi + '"]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false') })
    var lbl = card.querySelector('[data-elegido="' + oi + '"]'); if (lbl) lbl.textContent = b.dataset.valor
    // Lo elegido en cada opción
    var sel = {}; card.querySelectorAll('[data-opcion].is-on').forEach(function (x) { sel[x.dataset.opcion] = x.dataset.valor })
    var grupos = {}; card.querySelectorAll('[data-opcion]').forEach(function (x) { grupos[x.dataset.opcion] = 1 })
    var completo = Object.keys(grupos).every(function (k) { return sel[k] != null })
    var v = vars.find(function (x) { return Object.keys(sel).every(function (k) { return x.o[k] === sel[k] }) && (completo || x.a) }) || vars.find(function (x) { return Object.keys(sel).every(function (k) { return x.o[k] === sel[k] }) })
    // Disponibilidad de las demás opciones con lo elegido
    card.querySelectorAll('[data-opcion]').forEach(function (x) {
      var k = x.dataset.opcion, prueba = Object.assign({}, sel); prueba[k] = x.dataset.valor
      var ok = vars.some(function (y) { return y.a && Object.keys(prueba).every(function (kk) { return y.o[kk] === prueba[kk] }) })
      x.classList.toggle('is-sin', !ok)
    })
    if (!v) return
    var img = card.querySelector('.amzl__foto') || card.querySelector('[data-foto] img'); if (img && v.i) { img.removeAttribute('srcset'); img.src = (v.i.indexOf('//') === 0 ? 'https:' : '') + v.i }
    var oferta = v.c > v.p, pctN = oferta ? Math.round((v.c - v.p) * 100 / v.c) : 0
    var pc = card.querySelector('[data-pct]'); if (pc) { pc.hidden = !oferta; pc.textContent = '-' + pctN + '%' }
    var nm = card.querySelector('[data-normal]'); if (nm) { nm.hidden = !oferta; nm.innerHTML = 'Precio normal: <s>' + dinero(v.c) + '</s>' }
    var of = card.querySelector('[data-of]'); if (of) of.hidden = !oferta
    var pr = card.querySelector('[data-precio]'); if (pr) pr.innerHTML = precioAmz(v.p)
    var an = card.querySelector('[data-antes]'); if (an) { an.hidden = !(v.c > v.p); an.innerHTML = 'Antes: <s>' + dinero(v.c) + '</s>' }
    card.querySelectorAll('[data-enlace]').forEach(function (a) { a.href = a.href.split('?')[0] + '?variant=' + v.id })
    var bt = card.querySelector('[data-amz-boton]')
    if (bt) {
      bt.classList.remove('is-listo')
      if (!completo) { bt.classList.add('is-espera'); bt.removeAttribute('data-amz-agregar'); bt.textContent = 'Elige tu ' + (card.dataset.pide || 'opción') }
      else if (!v.a) { bt.classList.add('is-espera'); bt.removeAttribute('data-amz-agregar'); bt.textContent = 'Agotado' }
      else { bt.classList.remove('is-espera'); bt.dataset.amzAgregar = v.id; bt.textContent = bt.dataset.texto; bt.disabled = false }
    }
  })
  // El botón que todavía espera una talla: avisa cuál falta
  document.addEventListener('click', function (e) {
    var bt = e.target.closest('[data-amz-boton].is-espera'); if (!bt) return
    e.preventDefault(); var card = bt.closest('[data-amz-tarjeta]')
    card.querySelectorAll('.amzl__ops').forEach(function (g) { if (!g.querySelector('.is-on')) { g.classList.remove('is-falta'); void g.offsetWidth; g.classList.add('is-falta') } })
  }, true)


  /* Búsqueda sin resultados: probar partes de lo escrito y mostrar lo primero que aparezca */
  function parecidos () {
    document.querySelectorAll('[data-amz-parecidos]').forEach(function (box) {
      if (box.dataset.amzListo) return; box.dataset.amzListo = '1'
      var palabras = (box.dataset.terminos || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').split(/[^a-z0-9ñ]+/).filter(function (w) { return w.length >= 3 })
      palabras.sort(function (a, b) { return b.length - a.length })
      var intentos = []
      function sumar (x) { if (x && intentos.indexOf(x) < 0) intentos.push(x) }
      // Sin comodín: con «*» Shopify devuelve cualquier cosa. Shopify ya completa el final de la palabra solo.
      if (palabras.length > 1) palabras.forEach(sumar)
      palabras.forEach(function (w) { [5, 4].forEach(function (n) { if (w.length > n) sumar(w.slice(0, n)) }) })
      intentos = intentos.slice(0, 8)
      function limpio (x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') }
      var rejilla = box.querySelector('[data-amz-parecidos-rejilla]'), titulo = box.querySelector('[data-amz-parecidos-titulo]')
      function probar (i) {
        if (i >= intentos.length) return
        var u = new URL(location.href); u.searchParams.set('q', intentos[i]); u.searchParams.set('type', 'product'); u.searchParams.delete('page')
        fetch(u.toString()).then(function (r) { return r.text() }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html'), g = d.querySelector('[data-amz-rejilla]')
          // Solo vale si algún título contiene lo que se probó (la búsqueda de Shopify a veces trae cosas sin relación)
          var buenos = g ? Array.prototype.filter.call(g.children, function (c) { var n = c.querySelector('.amzl__nombre'); return n && limpio(n.textContent).indexOf(intentos[i]) >= 0 }) : []
          if (!buenos.length) { probar(i + 1); return }
          buenos.slice(0, 12).forEach(function (c) { rejilla.appendChild(document.importNode(c, true)) })
          titulo.textContent = (box.dataset.titulo || 'Mostrando resultados para «[busqueda]»').replace('[busqueda]', intentos[i])
          box.hidden = false
        }).catch(function () { probar(i + 1) })
      }
      probar(0)
    })
  }


  /* Descripción larga: se corta y se abre con «Ver más» */
  function descripciones () {
    document.querySelectorAll('[data-amz-desc]').forEach(function (d) {
      if (d.dataset.amzListo) return; d.dataset.amzListo = '1'
      var txt = d.querySelector('.amzl__desctxt'), b = d.querySelector('[data-amz-desc-mas]')
      if (txt.scrollHeight <= 130) return
      d.classList.add('is-corta'); b.hidden = false
      b.addEventListener('click', function () { var c = d.classList.toggle('is-corta'); b.textContent = c ? 'Ver más' : 'Ver menos' })
    })
  }
  function todo () { iniciar(); parecidos(); descripciones() }
  window.__amzColeccion = todo
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo()
  document.addEventListener('shopify:section:load', todo)
})()
